<template>
  <div class="sonar-progress-bar">
    <div
      :class="['sonar-progress-bar--progress', progressBarClass]"
      :style="`width: ${barProgress}%`"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'SonarProgressBar',
  props: {
    barProgress: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    progressBarClass() {
      return `sonar-progress-bar--${this.index + 1}`
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-progress-bar {
  position: relative;
  background: var(--glass-extra-light);
  height: 24px;
  width: 100%;
  @include mobile {
    width: 33.33% !important;
  }
  &--progress {
    position: absolute;
    left: 0;
    border-radius: 2px;
    height: 100%;
  }
  &--1 {
    border-radius: 4px 2px 2px 4px;
    background: var(--sonar-gradient-1);
  }
  &--2 {
    background: var(--sonar-gradient-2);
  }
  &--3 {
    border-radius: 2px 4px 4px 2px;
    background: var(--sonar-gradient-3);
  }
}
</style>
